export const GROUPS = {
  ADMIN: "Admin",
  HR: "HR",
  EMPLOYEE: "Employee",
  HIRING_MANAGER: "Hiring Manager",
  EXTERNAL_RECRUITER: "External Recruiter",
};

export const APPLICATION_STATUS = {
  AWAITING_USER_ACTION: "Awaiting User Action",
  SCREENING_IN_PROCESS: "Screening In-Process",
  SCREENED: "Screened",
  INTERVIEWS_IN_PROCESS: "Interviews In-Process",
  SCREENING_REJECTED: "Screening Rejected",
  POST_SCREENING_REJECTED: "Post Screening Rejected",
  OFFERED: "Offered",
  OFFER_ACCEPTED: "Offer Accepted",
  OFFER_REJECTED: "Offer Rejected",
  OFFER_RESCINDED: "Offer Rescinded",
};

export const APPLICATION_STATUS_ACTION = {
  MOVE_FORWARD: "move_forward",
  MOVE_BACKWARD: "move_backward",
};

export const APPLICATION_ACTIONS_ACCESS_LEVEL = {
  FULL: "full",
  LIMITED: "limited",
};

export const INTERVIEW_STATUS = {
  PENDING: "Pending",
  NOT_YET_SCHEDULED: "Not Yet Scheduled",
  SCHEDULED: "Scheduled",
  PENDING_FEEDBACK: "Pending Feedback",
  FEEDBACK_RECEIVED: "Feedback Received",
  MOVED_TO_NEXT_STAGE: "Moved to Next Stage",
  REJECTED: "Rejected",
  CANCELLED: "Cancelled",
};

export const JOB_POST_STATUS = {
  DRAFT: "Draft",
  PUBLISHED: "Published",
  CLOSED: "Closed",
  REQUISITION_CLOSED: "Requisition Closed",
};

export const EMAIL_STATUS = {
  DRAFT: "Draft",
  SENT: "Sent",
};

export const INTERVIEW_SCHEDULING_METHOD = {
  GOOGLE_CALENDAR: "Google Calendar",
  LOCAL: "Local",
};

export const INTERVIEW_FEEDBACK_STATUS = {
  SUBMITTED: "SUBMITTED",
  PENDING: "PENDING",
  DRAFT: "DRAFT",
};

export const INTERVIEW_KIT_TABS = {
  INTERVIEW_QNA: "interview-qna",
  RESUME: "resume",
  FEEDBACK_FORM: "feedback-form",
  SCREENING_RESULTS: "screening-results",
};

// Tabs on the applicant profile left column (Resume / Notes)
export const PROFILE_TABS = { RESUME: "resume", NOTES: "notes" };

export const DASHBOARD_ENTRIES_LIMITS = {
  UPCOMING_INTERVIEWS_DEFAULT: 4,
  PENDING_FEEDBACKS_DEFAULT: 2,
  PENDING_FEEDBACKS_HR: 3,
  PEDNING_APPROVALS_DEFAULT: 3,
  APPLICATIONS_TO_REVIEW: 3,
};

export const AI_FEATURES_GENERATION_STATUS = {
  PENDING: "PENDING",
  READY_FOR_GENERATION: "READY_FOR_GENERATION",
  IN_PROGRESS: "IN_PROGRESS",
  GENERATED: "GENERATED",
  FAILED: "FAILED",
};

// These values are consistent with the breakpoints in core ui
export const MOBILE_SCREEN_SIZE = 767.98;
export const TABLET_SCREEN_SIZE = 1023.98;

export const APPLICANT_SCREENING_SCORE_THRESHOLD = 50;

export const PASS_FAIL_STATUS = {
  PASS: "Pass",
  FAIL: "Fail",
};

export const FORM_MODES = {
  ADD: "add",
  EDIT: "edit",
  VIEW: "view",
};

export const USER_TYPES = {
  INTERNAL: "internal",
  EXTERNAL: "external",
};

export const TOAST_TYPES = {
  INFO: "info",
  SUCCESS: "success",
  WARNING: "warning",
  ERROR: "error",
  DOWNLOAD: "download",
};

export const APPLICANT_SOURCE = {
  SOURCED: "Sourced",
  APPLIED: "Applied",
  REFERRAL: "Referral",
  OUTSOURCED: "Outsourced",
};

export const CONSTRUCT_JOB_POST_PUBLIC_URL_MODES = {
  PUBLIC: "public",
  TRACKED: "tracked",
};

export const EVALUATION_FORM_SECTION_TYPES = {
  ASSESSMENT_FORM: "ASSESSMENT_FORM",
  SCORE_CARD: "SCORE_CARD",
};

export const FORM_CONFIG_OTHER_OPTION = {
  VALUE: "OTHER",
  LABEL: "Other",
};
